export const Style = ({ colors = [] }) => <g></g>
